const videos = document.querySelectorAll(".video");
const needsJSAPI = document.querySelector(".has-custom-poster");

[...videos].map(el => {
	if (el.querySelector(".has-custom-poster")) {
		console.log("Do some stuff");
		const img = el.querySelector("img");
		const container = el.querySelector(".has-custom-poster");
		img.addEventListener("click", e => {
			const x = new YT.Player(el.querySelector("iframe"), {
				playerVars: { controls: 1 },
				events: {
					onReady: () => {
						x.playVideo();
					},
				},
			});
			img.style.opacity = 0;
			container.classList.add("hide-play");
			setTimeout(() => (img.style.display = "none"), 200);
			console.log(x);
		});
	}
});
